<template>
  <AppAdSense
    v-if="!subscriptionStore.isPaidUser"
    ad-class="adsense adsense--footer"
    ad-style="display:block"
    ad-client="ca-pub-9118328092882671"
    ad-responsive="true"
    ad-format="auto"
    ad-slot="8925167743"
  />
</template>

<script setup lang="ts">
  import { useSubscriptionStore } from '$/stores/subscription'

  const subscriptionStore = useSubscriptionStore()
</script>

<style lang="sass" scoped>
  .adsense--footer
    min-height: 90px
    text-align: center
</style>
